import { render } from "./Footer.vue?vue&type=template&id=8a356f92&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=8a356f92&scoped=true&lang=css"

import exportComponent from "/builds/sprosec/spr-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a356f92"]])

export default __exports__